// extracted by mini-css-extract-plugin
module.exports = {"specsTable":"styles__specsTable--3k-Fc","loader":"styles__loader--1I5qz"};